<template>
  <div>
    <OnboardingTextSection>
      Сейчас вы находитесь в разделе <b>Аккаунты</b>. С их<br>
      помощью можно разделить или объединить бренды<br>
      или рекламодателей, которые вы продвигаете.
    </OnboardingTextSection>

    <OnboardingTextSection>
      <b>Все аккаунты</b> — аккаунты, которые вам доступны<br>
      для работы в системе. Среди них есть компания, в<br>
      которой вы работаете.
    </OnboardingTextSection>
  </div>
</template>

<script>
  import OnboardingTextSection from 'onboarding/onboardings/components/OnboardingTextSection';

  export default {
    name: 'AllAccountsTree',
    components: {OnboardingTextSection}
  };
</script>
